// src/pages/NewsPage.js
import { useState, useEffect } from 'react';
import useAuth from '../hooks/useAuth';
import api from '../services/api';
import CreateNewsForm from "../components/news/CreateNewsForm";
import LoadingSpinner from "../components/common/LoadingSpinner";

const NewsPage = () => {
  const { user } = useAuth();
  const [news, setNews] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState('');
  const [showCreateForm, setShowCreateForm] = useState(false);

  useEffect(() => {
    const fetchNews = async () => {
      try {
        const res = await api.get('/news');

        // ✅ Извлекаем массив новостей из res.data.news
        const newsData = res.data?.news;

        if (Array.isArray(newsData)) {
          setNews(newsData);
        } else {
          setNews([]);
          console.warn('Новости не являются массивом:', res.data);
        }
      } catch (err) {
        console.error('Ошибка загрузки новостей:', err);
        setError('Не удалось загрузить новости');
      } finally {
        setLoading(false);
      }
    };

    fetchNews();
  }, []);

  const handleNewsCreated = (newNews) => {
    // Добавляем новую новость в начало списка
    setNews(prev => [newNews, ...prev]);
  };

  const handleCloseModal = () => {
    setShowCreateForm(false);
  };

  return (
      <div className="main-content">
        <div className="page-header mb-4">
          <h1>Новости системы</h1>
          {user && <p className="text-muted">Добро пожаловать, {user.fullName}</p>}
          {user?.superuser && (
            <button
              className="btn btn-success mt-2"
              onClick={() => setShowCreateForm(true)}
            >
              Создать новость
            </button>
          )}
        </div>

        {user?.superuser && (
          <CreateNewsForm 
            onNewsCreated={handleNewsCreated} 
            show={showCreateForm} 
            onClose={handleCloseModal} 
          />
        )}

        {error && <div className="alert alert-danger">{error}</div>}

        {loading ? (
            // <div className="text-center">
            //   <div className="spinner-border" role="status">
            //     <span className="visually-hidden">Загрузка...</span>
            //   </div>
            // </div>
            <LoadingSpinner text="Загружаем звонки..." />
        ) : news.length === 0 ? (
            <p>Нет доступных новостей.</p>
        ) : (
            <div className="news-list">
              {news.map((item) => (
                  <div key={item.id} className="card mb-3 d-flex flex-row">
                    {/* Основное содержимое — слева */}
                    <div className="flex-grow-1 p-3 d-flex flex-column justify-content-center">
                      <div style={{display: 'flex', alignItems: 'center', gap: '8px'}}>
                        <h5 className="card-title mb-1" style={{margin: 0}}>{item.title}</h5>
                        {!item.is_viewed && (
                          <span className="badge bg-danger" style={{fontSize: '0.75em'}}>new</span>
                        )}
                      </div>
                      <p className="card-text mb-1">{item.message}</p>
                      <small className="text-muted">
                        {new Date(item.created_at).toLocaleString('ru-RU')}
                      </small>
                    </div>

                    {/* project_name — справа, такой же размер, как title */}
                    <div
                        className="d-flex align-items-center justify-content-center px-3 text-center bg-light border-start"
                        style={{minWidth: '150px'}}>
                      <h6 className="mb-0" style={{fontSize: '1rem', lineHeight: '1.2'}}>
                        {item.project_name}
                      </h6>
                    </div>
                  </div>
              ))}
            </div>
        )}
      </div>
  );
};

export default NewsPage;


